<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite"
          >新增</el-button
        >
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="data.Status === 2 || !canWrite"
          >保存</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          :disabled="!isSave || data.Status === 2 || !canWrite"
          @click="handleDelete"
          >删除</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="reView"
          v-if="data.Status !== 2"
          :disabled="!isSave || !canReview"
          >审核</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="cancelReView"
          v-if="data.Status === 2"
          :disabled="!isSave || !canReview"
          >弃审</el-button
        >
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave"
          @click="onPrint2(data)">打印</el-button
        >
      </div>
      <el-form
        :model="data"
        ref="form"
        :inline="true"
        :line-form="true"
        label-width="100px"
        :rules="rules"
        status-icon
      >
        <el-row style="margin-top: 18px">
          <el-form-item label="单据编码" label-width="100px" prop="DocNo">
            <span
              style="display: inline-block; width: 180px"
              v-if="Mode == 0 || data.Status === 2 || (isMustClear && !isClear)"
              class="detail-span"
              >{{ data.DocNo }}</span
            >
            <el-input
              style="width: 180px"
              v-else
              v-model="data.DocNo"
              placeholder="请输入单据编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="单据日期" label-width="100px" prop="DocDate">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              $commonJs.toDateString(data.DocDate)
            }}</span>
            <el-date-picker
              v-else
              v-model="data.DocDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 180px"
              @change="(v) => getPreviewNo(v)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="供应商:" prop="TradeUnitId" label-width="100px">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              data.TradeUnitName
            }}</span>
            <!-- <select-input
              v-else
              placeholder="请选择供应商"
              :label="data.TradeUnitName"
              v-model="data.TradeUnitId"
              @click="openTradeunit"
              @clear="clearTradeUnit"
            /> -->
            <el-select
              v-else
              v-model="data.TradeUnitId"
              filterable
              style="width: 180px"
            >
              <el-option
                v-for="item in tradeUnitList"
                :key="item.TradeUnitId"
                :value="item.TradeUnitId"
                :label="item.FullName"
                @click.native="setTradeunit(item)"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="往来单位" label-width="100px" prop="TradeUnitId">
            <span class="not-edit" v-if="data.Status === 2">{{
              data.TradeUnitName
            }}</span>
            <el-select
              v-else
              style="width: 180px"
              v-model="data.TradeUnitId"
              @change="changeTradeUnit"
            >
              <el-option
                v-for="item in tradeUnitList"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="业务类型">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              BusinessTypeName
            }}</span>
            <el-select
              v-else
              v-model="data.BusinessType"
              style="width: 180px"
              @change="changeBusinessType"
            >
              <el-option key="a1" label="应付款" :value="0"></el-option>
              <el-option key="a2" label="预付款" :value="1"></el-option>
              <el-option key="a3" label="直接付款" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经手人:" prop="EmpId">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              data.EmpName
            }}</span>
            <select-input
              v-else
              placeholder="请选择经办人"
              :label="data.EmpName"
              v-model="data.EmpId"
              @click="openEmp"
              style="width: 180px"
            />
          </el-form-item>
          <el-form-item label="折让金额" v-if="canPrice">
            <span class="not-edit">{{ data.TotalAllowanceAmount }}</span>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="摘要" prop="EmpId">
            <el-input
              :disabled="data.Status === 2 || (isMustClear && !isClear)"
              type="textarea"
              style="width: 500px"
              v-model="data.Summary"
              :autosize="{ minRows: 3 }"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>

      <div class="flex space-between align_items">
        <div class="el-form-item__label" style="margin-left: 8px">付款信息</div>
        <div>
          <el-button
            type="primary"
            style="margin-right: 8px"
            @click="add"
            :disabled="data.Status === 2 || (isMustClear && !isClear)"
            >添加</el-button
          >
        </div>
      </div>

      <el-table
        border
        class="table_bottom table-line tb-c-head tb-head-color"
        :data="tableData"
        stripe
        show-summary
        :summary-method="summaryFunc" 
      >
        <el-table-column
          label="结算方式"
          prop="SettleId"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              row.SettleName
            }}</span>
            <el-select
              v-else
              v-model="row.SettleId"
              @change="handleChange($event, row)"
            >
              <el-option
                v-for="item in settleList"
                :key="item.SettleId"
                :label="item.SettleName"
                :value="item.SettleId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="付款账户"
          prop="AccountId"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              row.AccountName
            }}</span>
            <el-select
              v-else
              v-model="row.AccountId"
              @change="changeAccount($event, row)"
            >
              <el-option
                v-for="item in accountList"
                :key="item.AccountId"
                :label="item.AccountName"
                :value="item.AccountId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="付款金额"
          prop="PayAmount"
          min-width="100"
          v-if="canPrice"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              $commonJs.toThousands(row.PayAmount)
            }}</span>
            <el-input
              v-else
              v-model="row.PayAmount"
              type="number"
              @change="changePayAmount($event, row)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="Remark"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              row.Remark
            }}</span>
            <el-input v-else v-model="row.Remark" @change="editT(row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row, $index }">
            <el-button
              type="text"
              @click="del(row, $index)"
              :disabled="data.Status === 2 || (isMustClear && !isClear)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="flex space-between mtx18 align_items" v-if="isDetail">
        <div class="el-form-item__label" style="margin-left: 8px">
          核销单据明细
        </div>
        <div class="flex">
          <el-form label-width="75px"  v-show="!isSave||isClear">
            <el-form-item label="单据日期">
              <range-picker
              :date="[params2.DocDateStart, params2.DocDateEnd]"
              @change="x=>{params2.DocDateStart=x.Start;params2.DocDateEnd=x.End;}"
              style="min-width:200px"
            />
            </el-form-item>
          </el-form>
          <div>
            <el-button
              v-show="!isSave||isClear"
              type="primary"
              style="margin: 0 0px 0 10px"
              @click="query"
              >查询</el-button
            >
            <el-button
              type="primary"
              @click="clear"
              :disabled="data.Status === 2"
              v-show="isSave"
              >取消核销</el-button
            >
          </div>
        </div>
      </div>
      <div class="flex" v-if="isDetail">
        <div class="el-form-item__label mrx24">
          待核销单据: {{ Detail.ToCount }}
        </div>
        <div class="el-form-item__label mrx24">
          已核销单据: {{ Detail.IsCount }}
        </div>
        <div class="el-form-item__label mrx24" v-if="canPrice">
          未核销金额: {{ $commonJs.toThousands(Detail.ToAmount)  }}
        </div>
        <div class="el-form-item__label mrx24" v-if="canPrice">
          本次核销金额: {{ $commonJs.toThousands(Detail.ThisAmount) }}
        </div>
        <div class="el-form-item__label mrx24" v-if="canPrice">
          核销差额: {{ $commonJs.toThousands(Detail.DiffAmount) }}
        </div>
      </div>

      <el-table
        border
        class="table_bottom table-line tb-c-head tb-head-color"
        :data="WoDocs"
        stripe
        v-if="isDetail"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"  align="center" fixed width="40">
        </el-table-column>
        <el-table-column
          label="单据类型"
          prop="SrcVouTypeName"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="单据编号"
          prop="SourceNo"
          align="center"
          min-width="100"
          sortable
        >
        <template slot-scope="{ row }">
          <el-button type="text" @click="toPage(row)">{{ row.SourceNo }}</el-button>
        </template>
        </el-table-column>
        <el-table-column
          label="单据日期"
          prop="DocDate"
          align="center"
          min-width="100"
          sortable
        >
          <template slot-scope="{ row }">
            <span class="not-edit" >{{
              $commonJs.toDateString(row.DocDate)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="总核销金额"
          prop="Amount"
          align="center"
          min-width="100"
          v-if="canPrice"
        >
        <template slot-scope="{ row }">
            <span class="not-edit" >{{
              $commonJs.toThousands(row.Amount)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="待核销金额"
          prop="PayAmount"
          align="center"
          min-width="100"
          v-if="canPrice"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" >{{
              $commonJs.toThousands(row.PayAmount)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="已核销金额"
          prop="AlreadyWriteoffAmount"
          align="center"
          min-width="100"
          v-if="canPrice"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" >{{
              $commonJs.toThousands(row.AlreadyWriteoffAmount)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="本次核销金额"
          prop="WriteoffAmount"
          align="center"
          min-width="100"
          key="column1"
          v-if="data.Status !== 2 && canPrice"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              $commonJs.toThousands(row.WriteoffAmount)
            }}</span>
            <el-input
              v-else
              v-model="row.WriteoffAmount"
              type="number"
              @change="changeWriteoffAmount($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="折让金额"
          prop="AllowanceAmount"
          align="center"
          min-width="100"
          v-if="canPrice"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              $commonJs.toThousands(row.AllowanceAmount)
            }}</span>
            <el-input
              v-else
              v-model="row.AllowanceAmount"
              type="number"
              @change="changeAllowanceAmount($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="Remark"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="data.Status === 2 || (isMustClear && !isClear)">{{
              row.Remark
            }}</span>
            <el-input v-else autosize v-model="row.Remark"></el-input>
          </template>
        </el-table-column>
      </el-table>

      <div class="mtx10">
        <div class="flex">
          <div class="text el-form-item__label">备注</div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model="data.Remark"
            :disabled="data.Status === 2 || (isMustClear && !isClear)"
          ></el-input>
        </div>
      </div>

      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">制单人</div>
            <div class="center el-form-item__label">{{ data.MakeEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewDate }}</div>
          </div>
        </div>
      </div>
    </div>
    <tradeunit-dialog
      ref="tradeunitDialog"
      in-dialog
      selectable
      @select="setTradeunit"
    />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import empDialog from "@/components/personnel/result/record/listDialog";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
import { number } from 'echarts/lib/export';
export default {
  name: "editpayment",
  components: {
    empDialog,
    tradeunitDialog,
  },
  data() {
    return {
      isSave: false,
      viewType: "create",
      Mode: 0,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      code_api: require("@/api/sy/serialCode").default,
      api: require("@/api/rp/pay").default,
      settleApi: require("@/api/ba/settle").default,
      accountApi: require("@/api/ba/account").default,
      woDoc: require("@/api/rp/woDoc").default,
      BusinessTypeName: "",
      accountList: [],
      tradeUnitList: [],
      settleList: [],
      data: {
        DocId: 0,
        DocDate: this.$commonJs.getToday(),
        DocNo: "",
        EmpId: "",
        EmpName: "",
        BusinessType: 0,
        TradeUnitId: "",
        TradeUnitName: "",
        TotalAllowanceAmount: null,
        Summary: "",
        MakeEmpName: "",
        MakeEmpId: 0,
        ReviewDate: "",
        ReviewEmpName: "",
        ReviewEmpId: 0,
        Status: 0,
        Remark: "",
        SourceId: 0,
        AbstractId: 0,
      },
      isClear: false, // 是否点击过取消核销
      WoDocs: [],
      params2: { 
        DocDateStart: "",
        DocDateEnd: ""
      },
      WoDts: [],
      tableData: [
        {
          T: 0,
          DtsId: 0,
          DocId: 0,
          AccountId: null,
          AccountName: "",
          SettleId: null,
          SettleName: "",
          PayAmount: null,
          Remark: "",
        },
      ],
      delTableData: [],
      isDetail: true,
      Detail: {
        ToCount: 0, //待核销单据
        IsCount: 0, //已核销单据
        ToAmount: 0, //未核销金额
        ThisAmount: 0, //本次核销金额
        DiffAmount: 0, //核销差额
      },
      initTableCount: 0, // 进入页面后表格的长度
      DtsTotal: 0, //付款总金额
      list: [],
      isAllDel: false, // 编辑模式下，把列表全部删除
      isClear: false, // 是否已取消核销
      isMustClear: false, // 是否修改要取消核销
      rules: {
        DocDate: [
          { required: true, message: "单据日期不能为空", trigger: "blur" },
        ],
        DocNo: [
          { required: true, message: "单据编码不能为空", trigger: "blur" },
        ],
        TradeUnitId: [
          { required: true, message: "供应商不能为空", trigger: "change" },
        ],
        BusinessType: [
          { required: true, message: "业务类型不能为空", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.viewType = this.$route.params.type;

    if (this.$route.params.type === "create") {
      this.getPreviewNo();
    } else if (this.$route.params.type === "edit") {
      let {BusinessType, Status} = this.$route.params.data;
      if(Status !== 2 && BusinessType === 0){
        this.$message.error('要修改数据请先取消核销!')
      }
      this.editInit(this.$route.params.data);
    }
  },

  computed: {
    canPrice() {
      return this.$permission.canPrice("/finance/cashier/payment");
    },
    canWrite() {
      return this.$permission.canWrite("/finance/cashier/payment");
    },
    canReview() {
      return this.$permission.canReview("/finance/cashier/payment");
    },
  },
  methods: {
    summaryFunc(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价'; 
          return;
        }
        if (index === 1 || index === 3) {
          sums[index] = ''; 
          return;
        }
        const values = data.map(item => Number(item[column.property]));  
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr); //Number转换为数值
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); 
        } else {
          sums[index] = '--';
        }
      });
      return sums; 
    },
    onPrint2(row) {
      var url = location.origin + "/#/customprintview/付款单/" + row.DocId;
      window.open(url, "_blank");
    },
    toPage(row){
      
      console.log('row', row)
      if(row.SrcVouTypeName === '进货单'){
        let data = {
          DocId: row.SourceId,
        }
        this.$router.push({
        name: "editStock",
          params: { mode: "edit", data },
        });
      }
      if(row.SrcVouTypeName === '加工费用单'){
        let data = {
          OutPocCostId: row.SourceId,
        }
        this.$router.push({
        name: "editMachiningCost",
          params: { mode: "edit", data },
        });
      }
      if(row.SrcVouTypeName === '其它应付单'){
        let data = {
          OtherPayId: row.SourceId,
        }
        this.$router.push({
        name: "editOtherDeal",
          params: { mode: "edit", data },
        });
      }
      if(row.SrcVouTypeName === '费用单'){
        let data = {
          DocId: row.SourceId,
        }
        this.$router.push({
        name: "editCost",
          params: { mode: "edit", data },
        });
      }
      if(row.SrcVouTypeName === '冲销单'){
        this.$router.push({
        name: "chargeoff",
          params: { DocNo: row.SourceNo },
        });
      }
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData({ TradeUnitTypes: [1, 2, 3] });
        // that.getData();
      });
    },
    clearTradeUnit() {
      this.data.TradeUnitId = null;
      this.data.TradeUnitName = "";
    },
    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
      this.data.TradeUnitType = data.TradeUnitType;
      this.WoDocs = [];
      this.Detail.ToCount = 0;
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    handleSelectionChange(list) {
      this.list = list;
      console.log('this.list', this.list)
      this.list.map((item) => {
        item.checkoutStatus = true;
      });
      //checkoutStatus
      // this.WoDocs.forEach(item=>{console.log(item,'item')})

      this.updateAmount();
      console.log("handleSelectionChange Detail", this.Detail);
    },
    changePayAmount(val, row) {
      this.editT(row);
      val = parseFloat(val);
      row.PayAmount = val;
      var items2 = this.tableData
        .filter((x) => !!x.PayAmount)
        .map((x) => parseFloat(x.PayAmount));
      if (items2.length > 0) {
        this.DtsTotal = items2.reduce((a, b) => {
          return Number(a) + Number(b);
        });
      } else this.DtsTotal = 0;

      this.updateAmount();
    },
    updateAmount() {
      var ids = this.list.map((x) => x.SourceNo);
      this.Detail.ThisAmount = 0;
      var amount = Number(this.DtsTotal);
      if (amount >= 0) {
        this.WoDocs.map((x) => {
          if (ids.includes(x.SourceNo)) {
            x.T = x.T === 0 ? 0 : 1;
            if (x.PayAmount >= amount) {
              x.WriteoffAmount = Number(amount.toFixed(2));
              this.Detail.ThisAmount += Number(amount.toFixed(2));
            } else if (x.PayAmount < amount) {
              x.WriteoffAmount =
                x.PayAmount > 0 ? Number(x.PayAmount.toFixed(2)) : 0;
              this.Detail.ThisAmount +=
                x.PayAmount > 0 ? Number(x.PayAmount.toFixed(2)) : 0;
            } else {
              x.WriteoffAmount = 0;
            }
            amount = amount - Number(x.WriteoffAmount.toFixed(2));
          }
        });
      } else {
        this.WoDocs.map((x) => {
          if (this.list.includes(x.SourceNo)) {
            x.T = x.T === 0 ? 0 : 1;
            this.data.TotalAllowanceAmount = 0;
            x.AllowanceAmount = 0;
            if (x.PayAmount <= amount) {
              x.WriteoffAmount = Number(amount.toFixed(2));
              this.Detail.ThisAmount += Number(amount.toFixed(2));
            } else if (x.PayAmount > amount) {
              x.WriteoffAmount =
                x.PayAmount < 0 ? Number(x.PayAmount.toFixed(2)) : 0;
              this.Detail.ThisAmount +=
                x.PayAmount < 0 ? Number(x.PayAmount.toFixed(2)) : 0;
            } else {
              x.WriteoffAmount = 0;
            }
            amount = amount - Number(x.WriteoffAmount.toFixed(2));
          }
        });
      }

      var total = 0;
      var toAmount = 0;
      this.list.map((item) => {
        total += Number(item.WriteoffAmount);
        toAmount += Number(item.PayAmount);
      });
      this.Detail.ThisAmount = Number((total-0).toFixed(2));
      this.Detail.ToAmount = Number((toAmount-0).toFixed(2));      
      this.Detail.DiffAmount = Number((toAmount - total).toFixed(2));
    },
    changeTradeUnit(val) {
      let item = this.tradeUnitList.filter((item) => {
        return item.value === val;
      })[0];
      this.data.TradeUnitName = item.label;
    },
    changeBusinessType(val) {
      if (val === 0) {
        this.isDetail = true;
        this.isMustClear = true;
      } else {
        this.isMustClear = false;
        this.isDetail = false;
      }
    },
    changeWriteoffAmount(val, row) {
      if (row.checkoutStatus == false)
        return this.$message({
          type: "warning",
          message: "请先勾选单据再进行填写金额",
        });
      this.editT(row);
      val = parseFloat(val);
      row.WriteoffAmount = Number(val.toFixed(2));
      if (val > 0) {
        if (row.PayAmount < 0) {
          row.WriteoffAmount = 0;
        } else {
          if (val > row.PayAmount) {
            val = row.PayAmount;
            row.WriteoffAmount = val;
          }
        }
      } else if (val < 0) {
        if (row.PayAmount > 0) {
          row.WriteoffAmount = 0;
        } else {
          if (val < row.PayAmount) {
            val = row.PayAmount;
            row.WriteoffAmount = val;
          }
        }
      }
      //WoDocs row.WriteoffAmount - row.AllowanceAmount

      // if(this.tableData.length==1)this.tableData[0].PayAmount=
      console.log("this.list", this.list);
      // if(this.tableData.length==1){
      //   this.tableData[0].PayAmount=0
      //   this.WoDocs.forEach(item=>{
      //   if(item.checkoutStatus){
      //     this.tableData[0].PayAmount+=item.WriteoffAmount-item.AllowanceAmount
      //   }
      // })
      // }
      //row.AllowanceAmount =row.PayAmount- row.WriteoffAmount;
      //row.AllowanceAmount=Number(row.AllowanceAmount||0).toFixed(2)
    },
    changeAllowanceAmount(val, row) {
      if (row.checkoutStatus == false)
        return this.$message({
          type: "warning",
          message: "请先勾选单据再进行填写金额",
        });
      this.editT(row);
      val = parseFloat(val);
      row.AllowanceAmount = val;
      if (val > row.PayAmount) {
        row.AllowanceAmount = row.PayAmount;
      }
      //if(row.AllowanceAmount>row.WriteoffAmount ) row.AllowanceAmount=row.WriteoffAmount
      let w = Number(
        Number(
          Number(row.WriteoffAmount) + Number(row.AllowanceAmount)
        ).toFixed(2)
      ); //两个金额总和
      if (w > row.PayAmount) {
        row.WriteoffAmount = row.PayAmount;
      } else {
        row.WriteoffAmount = w;
      }

      // if(this.tableData.length==1){
      //   this.tableData[0].PayAmount=0
      //   this.WoDocs.forEach(item=>{
      //   if(item.checkoutStatus){
      //      this.tableData[0].PayAmount+=item.WriteoffAmount-item.AllowanceAmount
      //   }
      // })
      // }
      //   if(w>row.PayAmount){
      //     // row.WriteoffAmount=row.PayAmount;
      //   }else{
      //     // row.WriteoffAmount=w;
      //   }
      // //row.WriteoffAmount =Number(row.WriteoffAmount||0).toFixed(2)
      let num = 0;
      this.list.map((item) => {
        num += Number(item.AllowanceAmount || 0);
      });
      this.data.TotalAllowanceAmount = Number(Number(num).toFixed(2));
    },
    setEmp(data) {
      this.data.EmpId = data.EmpId;
      this.data.EmpName = data.EmpName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("付款单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取付款单编号失败");
        }
      });
    },
    init() {
      const user = this.$store.state.user;
      if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
      }

      this.tradeUnitApi
        .list({ Status: 1, TradeUnitTypes: [1, 2, 3] })
        .then((res) => {
          if (res.Code == 0) {
            this.tradeUnitList = res.Data;
            // this.tradeUnitList = res.Data.map((item) => {
            //   return {
            //     key: item.TradeUnitId,
            //     label: item.FullName,
            //     value: item.TradeUnitId,
            //   };
            // });
          }
        });

      this.settleApi.list({ Status: 1 }).then((res) => {
        if (res.Code === 0) {
          console.log("settleApi res.Data", res.Data);
          this.settleList = res.Data;
        }
      });

      this.accountApi.list({ Status: 1 }).then((res) => {
        if (res.Code === 0) {
          console.log("accountApi res.Data", res.Data);
          this.accountList = res.Data;
        }
      });
    },
    editInit(data) {
      this.viewType = "edit";
      this.isSave = true;
      let {
        DocId,
        DocDate,
        DocNo,
        EmpId,
        EmpName,
        BusinessType,
        TradeUnitId,
        TradeUnitName,
        TotalAllowanceAmount,
        Summary,
        MakeEmpName,
        MakeEmpId,
        ReviewDate,
        ReviewEmpName,
        ReviewEmpId,
        Status,
        WoDocs,
        WoDts,
        Dts,
        Remark,
        SourceId,
        AbstractId,
      } = data;
      if (BusinessType === 0) {
        this.BusinessTypeName = "应付款";
        this.isDetail = true;
        if(Status !== 2){
          this.isMustClear = true;
          this.isClear = false;
          
        }else{
          this.isMustClear = false;
          this.isClear = false;
        }
        
      } else if (BusinessType === 1) {
        this.BusinessTypeName = "预付款";
        this.isDetail = false;
        this.isMustClear = false;
        this.isClear = false;
      } else if (BusinessType === 2) {
        this.isDetail = false;
        this.BusinessTypeName = "直接付款";
        this.isMustClear = false;
        this.isClear = false;
      }

      if (SourceId == null) {
        SourceId = 0;
      }
      if (AbstractId == null) {
        AbstractId = 0;
      }
      this.data = {
        DocId,
        DocDate,
        DocNo,
        EmpId,
        EmpName,
        BusinessType,
        TradeUnitId,
        TradeUnitName,
        TotalAllowanceAmount,
        MakeEmpName,
        MakeEmpId,
        ReviewDate,
        ReviewEmpName,
        ReviewEmpId,
        Status,
        Summary,
        Remark,
        SourceId,
        AbstractId,
      };

      Dts.forEach((item) => {
        item.T = null;
      });

      this.tableData = Dts;

    

      let arr = [];

      WoDocs.forEach((x) => {
        let o = {
          WoDocId: x.WoDocId,
          DocId: x.DocId,
          DocDate: x.DocDate,
          SourceId: x.SourceId || 0,
          SourceNo: x.SourceNo,
          SourceType: x.SrcVouType,
          SrcVouTypeName: x.SrcVouTypeName,
          Amount: x.Amount,
          PayAmount: Number(Number(x.Amount - x.AllWriteoffAmount).toFixed(2)),
          AlreadyWriteoffAmount: x.AllWriteoffAmount,
          WriteoffAmount: x.WriteoffAmount,
          AllowanceAmount: x.AllowanceAmount,
          Remark: x.Remark,
          T: null,
          checkoutStatus: false,
        };

        arr.push(o);
      });
      this.WoDocs = arr;
      this.initTableCount = this.WoDocs?.length ?? 0;
      this.Detail.IsCount = arr.length;
      this.list = [];
      var items2 = this.tableData
        .filter((x) => !!x.PayAmount)
        .map((x) => parseFloat(x.PayAmount));
      if (items2.length > 0) {
        this.DtsTotal = items2.reduce((a, b) => {
          return Number(a) + Number(b);
        });
      } else this.DtsTotal = 0;
      console.log("data", data);
    },
    handleChange(val, row) {
      this.editT(row);
      let item = this.settleList.filter((item) => {
        return item.SettleId === val;
      })[0];

      row.SettleId = item.SettleId;
      row.SettleName = item.SettleName;
      row.AccountId = item.AccountId;
      row.AccountName = item.AccountName;
    },
    changeAccount(val, row) {
      this.editT(row);
      let item = this.accountList.filter((item) => {
        return item.AccountId === val;
      })[0];
      row.AccountId = item.AccountId;
      row.AccountName = item.AccountName;
    },
    del(row, index) {
      this.$confirm("确认删除这条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (row.T !== 0) {
          row.T = 2;
          this.delTableData.push(row);
        }
        this.tableData.splice(index, 1);

        if (this.viewType === "edit" && this.tableData.length === 0) {
          this.isAllDel = true;
        }
      });
    },
    add() {
      let o = {
        T: 0,
        DtsId: 0,
        DocId: 0,
        AccountId: null,
        AccountName: "",
        SettleId: null,
        SettleName: "",
        PayAmount: null,
        Remark: "",
      };

      if (this.viewType === "edit") {
        this.isAllDel = false;
      }

      this.tableData.push(o);
    },
    clear() {
      var config = {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      };
      this.$confirm("确认清空已核销明细吗？", "提示", config)
        .then(() => {
          this.api.clear(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.isClear = true;
              this.$message({ type: "success", message: res.Msg });
              this.api.info(this.data.DocId).then((res) => {
                if (res.Code === 0) {
                  // this.$route.params.data = res.Data;
                  // this.editInit(res.Data);
                  this.isClear = true;
                  this.WoDocs = [];
                  this.Detail.ToCount = 0;
                  this.Detail.IsCount = 0;
                  this.Detail.ToAmount = 0;
                  this.Detail.ThisAmount = 0;
                  this.Detail.DiffAmount = 0;
                }
              });
            } else {
              this.$message({ type: "warning", message: res.Msg });
            }
          });
        })
        .catch(() => {});
    },
    query() {
      // console.log("查询");

      if (!this.data.TradeUnitId) {
        this.$message({ type: "warning", message: "请先选择往来单位" });
        return;
      }

      var loading = this.$loading({
        lock: true,
        text: "正在查询...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });

      this.woDoc
        .needPayList({ TradeUnitId: this.data.TradeUnitId, ...this.params2 })
        .then((res) => {
          // console.log(res);
          if (res.Code == 0) {
            console.log("res.Data", res.Data);
            if (res.Data.length == 0) {
              this.WoDocs = [];
              this.$message.warning("暂无单据明细");
              loading.close();
              return;
            }
            this.WoDocs = [];
            res.Data.forEach((x) => {
              this.WoDocs.push({
                WoDocId: 0,
                DocId: this.data.DocId,
                DocDate: x.DocDate,
                SourceId: x.SourceId,
                SourceNo: x.DocNo,
                SourceType: x.SrcVouType,
                SrcVouTypeName: x.SrcVouTypeName,
                Amount: x.Amount,
                PayAmount: Number(
                  Number(x.Amount - x.AlreadyWriteoffAmount).toFixed(2)
                ),
                AlreadyWriteoffAmount: x.AlreadyWriteoffAmount,
                WriteoffAmount: null,
                AllowanceAmount: null,
                Remark: "",
                checkoutStatus: false,
                T: 0,
              });
            });
            this.Detail.ToCount = res.Count;
            console.log("this.Detail", this.Detail);
            loading.close();
          } else {
            loading.close();
          }
        })
        .catch((err) => {
          console.error(err);
          loading.close();
        });
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: "warning", message: "请先进行保存再操作" });
        return;
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
        this.getPreviewNo();
        this.$route.params.type = "create";
        this.viewType = "create";
        this.init();
        this.isSave = false;

        setTimeout(() => {
          this.$refs.form.clearValidate();
        }, 30);
      }
    },
    handleDelete() {
      let Id = this.data.DocId;
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.api.delete({ Id }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.newAdd();
            // this.$emit('deleted')
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
    reView1() {
      let id = this.data.DocId;
      this.api.review({Id: id}).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    reView() {
      this.save(1);
    },
    cancelReView() {
      let id = this.data.DocId;
      this.api.back(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    save(type = 0) {
      var checkData = this.tableData.filter((item) => {
        return item.T != null;
      });
      console.log("checkData", checkData);
      if (
        (checkData.length == 0 && this.viewType === "create") ||
        this.isAllDel
      ) {
        this.$message({ type: "warning", message: "付款信息不能为空" });
        return;
      }

      var c = checkData.every((x) => !!x.SettleId);
      console.log("c", c, "!c", !c);
      if (!c) {
        this.$message({ type: "warning", message: "付款信息不能为空" });
        return;
      }

      //非应付款
      if (this.data.BusinessType !== 0) {
        // 构造保存的数据
        let Dts = this.tableData.filter((item) => {
          return item.T != null;
        });
        Dts = Dts.concat(this.delTableData);
        let o = {
          Dts,
          WoDocs: [],
          WoDts: [],
          ...this.data,
        };
        var loading = this.$loading({
          lock: true,
          text: "正在保存...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
        this.api
          .save(o)
          .then((res) => {
            if (res.Code === 0) {
              if (this.viewType === "create") {
                this.data.DocId = res.Data;
              }
              if (type !== 1) {
                this.$message.success(res.Msg);
              }
              this.isSave = true;

              this.api.info(this.data.DocId).then((res) => {
                if (res.Code === 0) {
                  this.$route.params.data = res.Data;
                  if (type === 1) {
                    this.reView1();
                  } else {
                    this.editInit(res.Data);
                  }
                }
              });
              loading.close();
            } else {
              this.$message({
                type: "warning",
                message: res.Msg,
              });
              loading.close();
            }
          })
          .catch((err) => {
            loading.close();
          });
      } else {
        // 验证是否能保存

        
       
        if(this.isClear === false && type === 1 && this.initTableCount !== 0){
          this.handleSelectionChange(JSON.parse(JSON.stringify(this.tableData)))
        }

        if(type === 1){
          if(this.list.length === 0){
            this.$message({ type: "warning", message: "请勾选核销明细" });
            return
          }
        }else{
          if(this.list.length === 0 ){
            this.$message({ type: "warning", message: "请勾选核销明细" });
            return;
          }
        }

        
       

        // 总付款金额
        let sumPayAmount_1 = this.tableData
          ?.map((item) => {
            return parseFloat(item.PayAmount);
          })
          ?.reduce((total, number) => {
            return total + number;
          });

        // // 总折让金额
        let sumAllowanceAmount = this.list
          ?.map((item) => {
            return parseFloat(item.AllowanceAmount || 0);
          })
          ?.reduce((total, number) => {
            return total + number;
          });

        // // 总本次核销金额
        let sumWriteoffAmount = this.list
          ?.map((item) => {
            return parseFloat(item.WriteoffAmount || 0);
          })
          ?.reduce((total, number) => {
            return total + number;
          });

        let payAmountHave0 = this.list
          ?.map((item) => {
            return parseFloat(item.PayAmount || 0);
          })
          ?.filter((v) => {
            return v === 0;
          });
        if (payAmountHave0.length > 0 && type !== 1) {
          this.$message({
            type: "warning",
            message: "勾选的条目存在待核销金额为0的条目",
          });
          return;
        }

        // 总待核销核销金额
        let sumPayAmount = this.list
          ?.map((item) => {
            return parseFloat(item.PayAmount || 0);
          })
          ?.reduce((total, number) => {
            return total + number;
          });

          console.log("sumPayAmount_1", sumPayAmount_1);
          
        console.log("sumPayAmount", sumPayAmount);
        sumPayAmount_1=Number((sumPayAmount_1-0).toFixed(2));
        sumWriteoffAmount =Number((sumWriteoffAmount-0) .toFixed(2));
        sumPayAmount=Number((sumPayAmount-0).toFixed(2));
        sumAllowanceAmount=Number((sumAllowanceAmount-0).toFixed(2));
        if (sumPayAmount_1 > sumPayAmount && type !== 1) {
          this.$message({
            type: "warning",
            message: "总付款金额不能大于总的待核销金额",
          });
          return;
        }
        console.log("sumWriteoffAmount", sumWriteoffAmount);
        console.log("sumPayAmount_1", sumPayAmount_1);
        console.log("sumAllowanceAmount", sumAllowanceAmount);
        if (
          sumWriteoffAmount === sumPayAmount_1 + sumAllowanceAmount ||
          type === 1
        ) {
          var obj = this.list.find(x => x.AllowanceAmount !== undefined);
          if(obj) {
            this.data.TotalAllowanceAmount = Number(sumAllowanceAmount).toFixed(2);
          }
          this.Detail.ThisAmount = Number(sumWriteoffAmount).toFixed(2);
          this.Detail.ToAmount = Number(sumPayAmount).toFixed(2);
          this.Detail.DiffAmount =
            Number(this.Detail.ToAmount) - Number(this.Detail.ThisAmount);
          this.Detail.DiffAmount = Number(this.Detail.DiffAmount).toFixed(2);
          this.Detail.IsCount = 0;
          // 构造保存的数据
          let Dts = this.tableData.filter((item) => {
            return item.T != null;
          });
          Dts = Dts.concat(this.delTableData);
          let WoDocs = this.list?.filter((item) => {
            return (
              item.T != null &&
              item.WriteoffAmount != 0 &&
              item.WriteoffAmount != null
            );
          });
          let o = {
            Dts,
            WoDocs,
            WoDts: [],
            ...this.data,
          };
          console.log("o", o);
          var loading = this.$loading({
            lock: true,
            text: "正在保存...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api
            .save(o)
            .then((res) => {
              if (res.Code === 0) {
                this.isClear = false;
                if (this.viewType === "create") {
                  this.data.DocId = res.Data;
                }
                if (type !== 1) {
                  this.$message.success(res.Msg);
                }
                this.isSave = true;

                this.api.info(this.data.DocId).then((res) => {
                  if (res.Code === 0) {
                    this.$route.params.data = res.Data;
                    if (type === 1) {
                    this.Detail.ThisAmount=0;
                    this.Detail.ToAmount=0;
                    this.Detail.DiffAmount=0;
                      this.reView1();
                    } else {
                      this.editInit(res.Data);
                    }
                  }
                });
                loading.close();
              } else {
                this.$message({
                  type: "warning",
                  message: res.Msg,
                });
                loading.close();
              }
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          this.$message({
            type: "warning",
            message:
              "表格勾选的本次核销金额总和要等于勾选的折让金额总和加上付款金额总和",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.mtx18 {
  margin-top: 18px;
}

.mrx24 {
  margin-right: 80px;
  color: #b3b3b3;
}

.flex {
  display: flex;
  .text {
    width: 60px;
  }
}
.space-between {
  justify-content: space-between;
}
.align_items {
  align-items: center;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}
.span {
  display: inline-block;
  width: 180px;
}
</style>
